import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/pages/login/login.component';
import { LoadingComponent } from './views/pages/loading/loading.component';
import { ForgottenpasswordComponent } from './pages/auth/forgottenpassword/forgottenpassword.component';
import { PasswordresetComponent } from './pages/auth/passwordreset/passwordreset.component';
import { HomeComponent } from './pages/home/home.component';
import { ChooseAppComponent } from './pages/settings/choose-app/choose-app.component';

import { AdminGuard } from './guards/admin.guard';
import { LoggedInGuard } from './guards/logged-in.guard';
import { LoggedOutGuard } from './guards/logged-out.guard';
import { AccountGuard } from './guards/account.guard';
import { PrivacyGuard } from './guards/privacy.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'loading',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: {
          title: 'Home'
        },
        canActivate: [LoggedInGuard, AccountGuard]
      },
      {
        path: 'mgmt',
        loadChildren: () =>
          import('./pages/mgmt/mgmt.module').then((m) => m.MgmtModule),
          canActivate: [LoggedInGuard, AccountGuard]
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.module').then((m) => m.ReportsModule),
          canActivate: [LoggedInGuard, AccountGuard]
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.module').then((m) => m.SettingsModule),
          canActivate: [LoggedInGuard]
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: 'awards',
        loadChildren: () =>
          import('./pages/awards/awards.module').then((m) => m.AwardsModule),
          canActivate: [LoggedInGuard, AccountGuard, PrivacyGuard]
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./pages/account/account.module').then((m) => m.AccountModule),
          canActivate: [LoggedInGuard, AdminGuard]
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedOutGuard],
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'forgottenpassword',
    component: ForgottenpasswordComponent,
    canActivate: [LoggedOutGuard],
    data: {
      title: 'Forgotten Password'
    }
  },
  {
    path: 'passwordreset',
    component: PasswordresetComponent,
    canActivate: [LoggedOutGuard],
    data: {
      title: 'Reset Password'
    }
  },
  {
    path: 'loading',
    component: LoadingComponent,
    data: {
      title: 'Loading'
    }
  },
  {
    path: 'app',
    component: ChooseAppComponent,
    data: {
      title: 'The OK Alone App'
    }
  },
  {path: '**', redirectTo: 'loading'}
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
